import { SkipNavContent as ChakraSkipNavContent } from '@chakra-ui/skip-nav'
import { SkipNavContentProps as ChakraSkipNavContentProps } from '@chakra-ui/skip-nav'
import { SwashbuckleComponentProps } from '../../types'
import { TextProps } from '../Text/Text'

interface SkipNavContentProps
  extends SwashbuckleComponentProps<ChakraSkipNavContentProps> {
  children: React.ReactElement<TextProps>
}

export const SkipNavContent = ({
  'data-qa': dataQa,
  className,
  ...chakraProps
}: SkipNavContentProps) => (
  <ChakraSkipNavContent
    data-qa={dataQa}
    className={className}
    {...chakraProps}
  />
)

SkipNavContent.displayName = 'SkipNavContent'
